// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.list-group>li.list-group-item[data-v-7b6a48f8]{border-left-width:0;border-right-width:0;border-radius:0}", ""]);
// Exports
module.exports = exports;
